import { TranslationFunction } from 'i18next';

const kbLink = (t: TranslationFunction, path: string) => t(`support-link-${path}`);

export interface KBLinks {
  AboutPrivacyCookies: string;
  PrivacyToolsDescriptionLearnMore: string;
  DisplayCookieBannerOnSite: string;
  CreatingAPrivacyPolicy: string;
  AddPrivacyPolicyLearnHow: string;
  AudienceVisitorsReadMore: string;
  ContactSupport: string;
  PublishYourSite: string;
  ReviewCookieSocialFeatures: string;
  ReviewCookieThirdParty: string;
  ReviewCookieCustomCode: string;
}

export const initKBLinks = (t: TranslationFunction): KBLinks => ({
  AboutPrivacyCookies: kbLink(t, 'about-privacy-cookies'),
  PrivacyToolsDescriptionLearnMore: kbLink(t, 'privacy-tools-description-learn-more'),
  DisplayCookieBannerOnSite: kbLink(t, 'display-cookie-banner-on-site'),
  CreatingAPrivacyPolicy: kbLink(t, 'creating-a-privacy-policy'),
  AddPrivacyPolicyLearnHow: kbLink(t, 'add-privacy-policy-learn-how'),
  AudienceVisitorsReadMore: kbLink(t, 'audience-visitors-read-more'),
  ContactSupport: kbLink(t, 'contact-support'),
  PublishYourSite: kbLink(t, 'publish-your-site'),
  ReviewCookieSocialFeatures: kbLink(t, 'review-cookie-social-features'),
  ReviewCookieThirdParty: kbLink(t, 'review-cookie-third-party'),
  ReviewCookieCustomCode: kbLink(t, 'review-cookie-custom-code'),
});
